import React from "react";
import FeatureTable from "./List/ListFeature";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import "../../../components/common/css/datatable.scss";
import "../../../components/common/css/index.scss";

const Feature = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <FeatureTable />
      </div>
    </div>
  );
};

export default Feature;
